<template>
  <div class="app">
    <div class="app__spinner" v-if="showSplash">
      <dx-spinner :active="true" />
    </div>
    <router-view v-if="!showSplash" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { DxSpinner } from './components'
export default {
  name: 'App',
  components: { DxSpinner },
  data () {
    return {
      showSplash: true
    }
  },
  methods: {
    ...mapActions(['checkLogin']),
    removeSplash () {
      this.showSplash = false
    }
  },
  created () {
    this.checkLogin().then((result) => {
      if (result && result.success) {
        this.redirectAfterLogin()
      }
      this.removeSplash()
    }).catch(() => {
      this.removeSplash()
    })
  }
}
</script>

<style lang="scss">
@import 'scss/styles';
</style>



// WEBPACK FOOTER //
// src/App.vue